export const ResourceViewerI18n = {
  resourceViewer: {
    AssignButton: 'Assign',
    RadioSwitcher: {
      altText: 'Select language',
      chooseALanguage: 'Resource language:',
      en: 'English',
      es: 'Spanish',
      language: 'Language'
    },
    Navigation: {
      backToResources: 'Go back to ...?'
    },
    DownloadButton: 'Download',
    DownloadAll: {
      downloadFailed: 'Download failed'
    },
    CopyClipboard: {
      copied: 'Copied!',
      copyResource: 'Copy {{resource}}',
      linkShare: 'Copy link to share'
    },
    Assignments: {
      assignedOn: 'Assigned',
      dueDate: 'Due date',
      UploadButton: "Upload",
      DoneButton: "I'm Done",
      doneARIA: 'done uploading',
      done: 'Done',
      instructions: 'Assignment instructions',
      Header: {
        dateTime: '{{date}} at {{time}}'
      },
      errorMessage: {
        closedDeletedAssignment: 'Sorry, the teacher has deleted/closed this assignment and it’s no longer available.',
        closedAssignment: 'Sorry, the teacher has closed this assignment and it’s no longer available.',
        deletedAssignment: 'Sorry, the teacher has deleted this assignment and it’s no longer available.',
        genericError: 'An error has occurred, please try again.',
        doneError: 'Sorry the assignment could not be marked as DONE. Please try again or contact your administrator.',
        sessionError: `We're sorry, your session timed out and we could not save your latest changes. Please log back in to continue working on this assignment.`
      }
    },
    FileUploader: {
      fileDetails: 'You can add images, slides, and pdf files less than 100 MB',
      dragableZone: 'Drag and drop your files here or',
      browseOption: 'Browse',
      browseOptionARIA: 'browse your files to upload',
      buttonShowFileExtensions: 'Show me supported files',
      buttonShowFileExtensionsARIA: 'Show me supported files',
      filesExtensionAccepted: '(.doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .pdf, .odt, .ods, .odp) and Images (.jpg, .jpeg, .bmp, .gif, .png)'
    },
    ModalCard: {
      closeModal: 'Close modal card.'
    },
    FileList: {
      failedUpload: 'File could not be uploaded. Try again',
      failedUploadSize: 'File size is too large',
      failedUploadType: 'The file format is not valid',
      successfulUpload: 'Uploaded',
      removeFile: 'Remove',
      uploading: 'Uploading...',
      ariaLabelRemoveFile: ' {{fileName}} uploaded, remove'
    },
    Redirect: {
      goToTodo: 'Return to Home.'
    },
    Modals: {
      confirmationModal: {
        title: 'Are you sure you are finished?',
        description: 'Select “yes” to send your completed assignment to your teacher.',
        confirm: 'YES',
        cancel: 'NO'
      },
      uploadModal: {
        title: 'Upload a file'
      },
      annotationErrorModal: {
        title: 'Session Time Out',
        description: 'Your changes are not saved. Please log back in to continue working on this assignment.',
        confirm: 'OK'
      },
      copyrightModal: {
        title: 'Caption for {{title}}'
      }
    },
    Events: {
      click: 'Click',
      cancel: 'Cancel',
      confirm: 'Confirm',
      cancelARIA: 'cancel uploads',
      confirmARIA: 'confirm',
      Redirect: {
        goToTodo: 'Return to Home.'
      }
    },
    Months: {
      january: {
        short: 'Jan'
      },
      february: {
        short: 'Feb'
      },
      march: {
        short: 'Mar'
      },
      april: {
        short: 'Apr'
      },
      may: {
        short: 'May'
      },
      june: {
        short: 'June'
      },
      july: {
        short: 'July'
      },
      august: {
        short: 'Aug'
      },
      september: {
        short: 'Sept'
      },
      october: {
        short: 'Oct'
      },
      november: {
        short: 'Nov'
      },
      december: {
        short: 'Dec'
      }
    },
    Dates: {
      today: 'Today'
    }
  }
};